import React from "react";
import { Icon as NBIcon } from "native-base";

export const Icon = ({ ...props }: any) => {
  return <NBIcon {...props}></NBIcon>;
};
